var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"edu-top-header"},[_c('div',{staticClass:"edu-top-logo"},[_c('img',{staticClass:"logo",attrs:{"src":require("../../statics/images/logo.png")}}),_c('div',{staticClass:"logo-tips"},[_vm._v("广东省妇女儿童活动中心"),_c('br'),_vm._v("网上报名系统")])]),_c('img',{staticClass:"edu-top-header-bg",attrs:{"src":require("../../statics/images/photo_top_bg.jpg")}})])
}]

export { render, staticRenderFns }